import * as React from 'react';
import { withRouter, Link, Redirect } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import Routes from 'src/core/Routes';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';
import { PageProps } from 'src/models/common/ComponentProps';

import DataTable, {
    DataTableColumnProps,
    Renderer,
    Filterer,
    DataTableButton,
    DataTableButtonReset
} from 'src/components/common/DataTable';

import TableRequestDTO from 'src/models/datatable/TableRequestDTO';
import TableResponseDTO from 'src/models/datatable/TableResponseDTO';
import ActivityDTO from 'src/models/activity/ActivityDTO';
import ActivityApiController from 'src/api/ActivityApiController';
import { Divider } from 'antd';


export interface ActivitiesProps extends PageProps<{}>, LocalizeContextProps {}

interface ActivitiesState {
    loading: boolean;
    surveys: ActivityDTO[];
    quizzes: ActivityDTO[];
}

class Activities extends React.Component<ActivitiesProps, ActivitiesState> {
    constructor(props: ActivitiesProps) {
        super(props);
        bindAllOfThis(this, Activities.prototype);

        this.state = {
            surveys: [],
            quizzes: [],
            loading: true
        };
    }

    private fetchSurveys(requestState: TableRequestDTO, checkEcho: () => boolean, callback: (response: TableResponseDTO<ActivityDTO>) => void): void {
        this.setState({ loading: true });

        ActivityApiController.getActivityTableData(requestState, true)
            .then(results => {
                if (!checkEcho()) {
                    return;
                }

                let surveys = results.data.results ? results.data.results : [];

                this.setState({
                    surveys: surveys,
                    loading: false
                });

                callback(results.data);
            });
    }

    private fetchQuizzes(requestState: TableRequestDTO, checkEcho: () => boolean, callback: (response: TableResponseDTO<ActivityDTO>) => void): void {
        this.setState({ loading: true });

        ActivityApiController.getActivityTableData(requestState, false)
            .then(results => {
                if (!checkEcho()) {
                    return;
                }

                let quizzes = results.data.results ? results.data.results : [];

                this.setState({
                    quizzes: quizzes,
                    loading: false
                });

                callback(results.data);
            });
    }

    private customTableColumns(): DataTableColumnProps<ActivityDTO>[] {
        let editLink = (text, record: ActivityDTO) => Routes.getRoute(Routes.ADMIN_ADD_EDIT_ACTIVITY, record.activityId);

        return [
            DataTable.StandardColumns.Text('admin.activities.columnHeader1', 'title'),
            DataTable.StandardColumns.Link('admin.common.editColumnHeader', 'edit', editLink, 'edit')
        ];
    }

    render() {
        return <div>
            <h2>{this.props.translate('admin.activities.tableHeader1')}</h2>

            <DataTable
                serverSide={true}
                tableProps={{ rowKey: 'activityId', loading: this.state.loading }}
                columns={this.customTableColumns()}
                data={this.state.surveys}
                fetchData={this.fetchSurveys}
                buttonBar={[
                    new DataTableButtonReset()
                ]} />

            <br /><br />

            <h2>{this.props.translate('admin.activities.tableHeader2')}</h2>

            <DataTable
                serverSide={true}
                tableProps={{ rowKey: 'activityId', loading: this.state.loading }}
                columns={this.customTableColumns()}
                data={this.state.quizzes}
                fetchData={this.fetchQuizzes}
                buttonBar={[
                    new DataTableButtonReset()
                ]} />
        </div>;
    }
}

export default withLocalize(Activities as any) as any;



// WEBPACK FOOTER //
// ./src/pages/admin/Activities.tsx